import { useState, useEffect } from "react";
import axios from "../axiosConfig";

export const useDevelopment = (organizationSurveyId, t) => {
  const [developmentData, setDevelopmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDevelopment = async () => {
      try {
        const response = await axios.get(
          `/survey_reports/${organizationSurveyId}/development`
        );
        setDevelopmentData(response.data);
      } catch (err) {
        console.error("Failed to load development:", err);
        setError(t("reports.development.error"));
      } finally {
        setLoading(false);
      }
    };

    fetchDevelopment();
  }, [organizationSurveyId, t]);

  return { developmentData, loading, error };
};